import Icon from "@imminently/decisively-ui/Icon";
import Button from "@imminently/decisively-ui/Button";
import Typography from "@mui/material/Typography";
import React from "react";

const ChevronDownJSX = <Icon name="expand" />;
const ChevronUpJSX = <Icon name="collapse" />;

export interface IProps {
  heading: string;
  content: React.ReactElement;
  collapsed: boolean;
  toggleCollapsed: () => unknown;
  onAdd?: () => unknown;
  className?: string;
}

export const _: React.FC<IProps> = React.memo((p) => {
  const { heading, content, toggleCollapsed, collapsed, className, onAdd } = p;
  const onAddClick: React.MouseEventHandler<HTMLButtonElement> | undefined = React.useMemo(
    () =>
      onAdd &&
      ((e) => {
        e.stopPropagation();
        onAdd();
      }),
    [onAdd],
  );

  return (
    <div className={`flex flex-col gap-2 ${className ?? ""}`.trim()}>
      <div className="group flex h-8 cursor-pointer items-center justify-between" onClick={toggleCollapsed}>
        <Typography variant="h6">{heading}</Typography>

        <div className="flex items-center">
          {onAddClick && (
            <Button icon
              label="Add"
              onClick={onAddClick}
              className="invisible group-hover:visible"
            >
              <Icon name="add" />
            </Button>
          )}
          {collapsed ? ChevronDownJSX : ChevronUpJSX}
        </div>
      </div>

      {collapsed ? null : content}
    </div>
  );
});
_.displayName = "components/Collapsable";
